import type { ActionButtonType } from "./ActionButton";
import CreateTaskModal from "../../task/modal/CreateTaskModal.vue";

const CreateA3A5Button: ActionButtonType = {
  label: "components.eventAction.event.actionButtons.CreateTaskButton.text",
  modalComponent: CreateTaskModal,
  disabled: false,
};
export default CreateA3A5Button;
